/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import LegacyLockFilledIcon from '@atlaskit/icon/glyph/lock-filled';
import LockFilledIcon from '@atlaskit/icon/utility/lock-locked';
import Lozenge from '@atlaskit/lozenge';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Inline, Text, xcss } from '@atlaskit/primitives';
var headingStyles = css({
  font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
  letterSpacing: 0
});
var iconWrapperStyles = xcss({
  display: 'flex',
  paddingInline: 'space.025'
});

/**
 * __Header items__
 *
 * Comment header items.
 *
 * @internal
 */
var Header = function Header(_ref) {
  var author = _ref.author,
    edited = _ref.edited,
    isError = _ref.isError,
    isSaving = _ref.isSaving,
    restrictedTo = _ref.restrictedTo,
    savingText = _ref.savingText,
    time = _ref.time,
    testId = _ref.testId,
    type = _ref.type,
    _ref$headingLevel = _ref.headingLevel,
    headingLevel = _ref$headingLevel === void 0 ? '3' : _ref$headingLevel;
  var Heading = "h".concat(headingLevel);
  var shouldRender = author || time || restrictedTo || isSaving && savingText || edited || type;
  return shouldRender ? jsx(Heading, {
    css: headingStyles
  }, jsx(Inline, {
    alignBlock: "center",
    testId: testId,
    space: "space.100",
    as: "span"
  }, author, type && jsx(Lozenge, {
    testId: testId && "".concat(testId, "-type")
  }, type), time && !isSaving && !isError && time, edited || null, isSaving ? savingText : null, restrictedTo && jsx(Text, {
    color: "color.text.subtlest"
  }, jsx(Inline, {
    alignBlock: "center",
    space: "space.050",
    as: "span"
  }, "\u2022", fg('platform-visual-refresh-icons-legacy-facade') || fg('platform.design-system-team.enable-new-icons') ? jsx(Box, {
    as: "span",
    xcss: iconWrapperStyles
  }, jsx(LockFilledIcon, {
    color: "currentColor",
    label: ""
  })) :
  // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
  jsx(LegacyLockFilledIcon, {
    size: "small",
    label: ""
  }), restrictedTo)))) : null;
};
Header.displayName = 'CommentHeader';
export default Header;